// extracted by mini-css-extract-plugin
module.exports = {"vUiHueLighter":"#fafafa","vUiHueDark":"#ccc","wrapper":"EmptyView__wrapper___Yjus6","content":"EmptyView__content___rOGbR"};